import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledShowConnectionButton = styled(Button)`
  color: ${({ theme }) => theme.colors.grey[200]};
  margin-bottom: 4.6rem;
  gap: 1rem;
`;
